import { Controller } from "remult";

@Controller("landing-page-methods")
export class LandingPageConfigMethods { }
